import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { RecDoctor } from 'models/RecDoctorModel';


const RecDoctorList: React.FC = () => {
  const width = { name: 54, phone: 20, email: 20 };
  const [formId, formName] = [Code.Form.Id.RECDOCTOR, Code.Form.Name.RECDOCTOR];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [recdoctorData, setRecDoctorData] = useState<RecDoctor[]>([]); 
  const [selectedRecDoctor, setselectedRecDoctor] = useState<RecDoctor | null>(null);
  const triggers = [pno, pageRows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.RecDoctor.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([Name.RecDoctor.Id, Name.RecDoctor.FullName, Name.RecDoctor.Phone, Name.RecDoctor.Email]),
    });
     
    await API.Data.List<RecDoctor>(url, setRecDoctorData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, recdoctorData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Doctor, width.name],
                [Title.Phone, width.phone], 
                [Title.Email, width.email]
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(recdoctorData) && (
              <Control.Grid.Row>
                {recdoctorData.map((recdoctorData) => { const path = Utility.Join.Edit(Privilege,formName, recdoctorData.recdoctor_key); return (
                <Control.Grid.Data<RecDoctor> key={recdoctorData.recdoctor_id} itemKey={recdoctorData.recdoctor_key} data={recdoctorData} setMenuPosition={setMenuPosition} setSelectedData={setselectedRecDoctor} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={recdoctorData.recdoctor_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={path} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Link path={path} width={width.name} iframeRef={iframeRef} value={Utility.Get.FullName(recdoctorData,Code.Form.Name.RECDOCTOR)} />
                  <Control.Grid.Items values={[
                    [recdoctorData.recdoctor_phone, width.phone], 
                    [recdoctorData.recdoctor_email, width.email]
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={recdoctorData.recdoctor_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={recdoctorData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName, selectedRecDoctor?.recdoctor_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedRecDoctor?.recdoctor_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default RecDoctorList;